/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const PlusCircleIcon = ({
  className,
  style: styleFromProps,
  color = 'white',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M12.129 7.80645V8.19355C12.129 8.40645 11.9548 8.58064 11.7419 8.58064H8.58064V11.7419C8.58064 11.9548 8.40645 12.129 8.19355 12.129H7.80645C7.59355 12.129 7.41935 11.9548 7.41935 11.7419V8.58064H4.25806C4.04516 8.58064 3.87097 8.40645 3.87097 8.19355V7.80645C3.87097 7.59355 4.04516 7.41935 4.25806 7.41935H7.41935V4.25806C7.41935 4.04516 7.59355 3.87097 7.80645 3.87097H8.19355C8.40645 3.87097 8.58064 4.04516 8.58064 4.25806V7.41935H11.7419C11.9548 7.41935 12.129 7.59355 12.129 7.80645ZM16 8C16 12.4194 12.4194 16 8 16C3.58065 16 0 12.4194 0 8C0 3.58065 3.58065 0 8 0C12.4194 0 16 3.58065 16 8ZM14.9677 8C14.9677 4.13226 11.829 1.03226 8 1.03226C4.13226 1.03226 1.03226 4.17097 1.03226 8C1.03226 11.8677 4.17097 14.9677 8 14.9677C11.8677 14.9677 14.9677 11.829 14.9677 8Z"
        fill={color}
      />
    </svg>
  );
};
